import { render, staticRenderFns } from "./BadgePrivate.vue?vue&type=template&id=17547f02&scoped=true&"
import script from "./BadgePrivate.vue?vue&type=script&lang=js&"
export * from "./BadgePrivate.vue?vue&type=script&lang=js&"
import style0 from "./BadgePrivate.vue?vue&type=style&index=0&id=17547f02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17547f02",
  null
  
)

export default component.exports